import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitMergeBaseAction extends WorkerAction {
  type: GitAction.MergeBase;
  params: { ref1: string; ref2: string };
}

export class GitMergeBaseActionError extends WorkerActionError {}

export async function GitMergeBaseActionFn({ lg, params }: WorkerFnParams<GitMergeBaseAction>): Promise<string> {
  try {
    const { ref1, ref2 } = params;
    return lg.callAndCaptureOutput(['merge-base', ref1, ref2]);
  } catch (err) {
    throw new GitMergeBaseActionError(err);
  }
}
